import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=51333f1a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=51333f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51333f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51333f1a')) {
      api.createRecord('51333f1a', component.options)
    } else {
      api.reload('51333f1a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=51333f1a&scoped=true&", function () {
      api.rerender('51333f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21Yv1baC93sym/JS/comp/GuestBox.vue"
export default component.exports